const ROLE_NAME_KEYS = {
    guest: "common.roles.guest",
    admin: "common.roles.admin",
    teacher: "common.roles.teacher",
    case_manager: "common.roles.caseManager",
    curriculum: "common.roles.curriculum",
    psychologist: "common.roles.psychologist",
    student: "common.roles.student",
    admin_system: "common.roles.adminSystem",
};

export const getRoleNameKey = (roleID) => {
    return ROLE_NAME_KEYS[roleID];
};
